import type {
  NextOutboundCallRequest,
  OutboundCallResponse,
  TestCallOptions,
  TestCallRequest,
  TestCallResponse,
} from '@api-contracts/api';
import backendHttpClient from '@services/_httpClient/backend.http-client';

import { VoiceRepository } from './repository';

class VoiceService extends VoiceRepository {
  public async createTestCall(
    request: TestCallRequest,
  ): Promise<TestCallResponse> {
    const response = await backendHttpClient.post<
      TestCallResponse,
      TestCallRequest
    >({
      body: request,
      path: '/calls/test',
    });
    return response.data;
  }

  public async getTestCallOptions(): Promise<TestCallOptions> {
    const response = await backendHttpClient.get<TestCallOptions>({
      path: '/calls/test/options',
    });
    return response.data;
  }

  public async launchNextOutboundCall(
    request: NextOutboundCallRequest,
  ): Promise<OutboundCallResponse> {
    const response = await backendHttpClient.post<
      OutboundCallResponse,
      NextOutboundCallRequest
    >({
      body: request,
      path: '/calls/outbound/next',
    });

    return response.data;
  }
}

export const voiceService = new VoiceService();
